import {Component, forwardRef, Injectable, Injector, Optional, SkipSelf} from "@angular/core";
import { switchClass } from "@wm/core";
import {
  StylableComponent,
  styler,
  APPLY_STYLES_TYPE, IWidgetConfig, provideAsWidgetRef, Parent, register
} from "@wm/components-base";
import {WmsTranscludeDirective} from "../wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-page-content app-content-column';
const WIDGET_CONFIG: IWidgetConfig = {widgetType: 'wm-page-content', hostClass: DEFAULT_CLS};

@Component({
  selector: '[wmPageContent]',
  template: `<div class="app-ng-transclude" wmsTransclude>
              <ng-content></ng-content>
            </div>`,
  providers: [
    provideAsWidgetRef(PageContentComponent)
  ],
  imports: [WmsTranscludeDirective],
  standalone: true
})
export class PageContentComponent extends StylableComponent {
  static initializeProps = register('wm-page-content');

  constructor(inj: Injector,
              @Optional() override viewParent: Parent
  ) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
  }

  override onPropertyChange(key: string, nv: any, ov?: any){
    if(key === 'columnwidth'){
      switchClass(this.nativeElement, `col-md-${nv} col-sm-${nv}`, `col-md-${ov} col-sm-${ov}`);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }
}
